var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"VChartComWrap",staticClass:"VChartComWrap"},[_c('div',{ref:"EChart",staticClass:"VChartCom"})])}
var staticRenderFns = []

export { render, staticRenderFns }